





































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop } from  'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { SwModal, SwModalBody, SwModalFooter } from '@libs-uuif/shared/sw-modal';
import { SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
const cssPrefix = 'catalogUnit';
@Component({
  components:{
    ...UUIFComponents,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwSelect,
  },
})
export default class DataCenterSelection extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop()
  showDCModal: any;

  @Prop()
  options: any;

  @Prop()
  selectedDc: any;

  dcSelected: any = '';
  list: any;

  onClickAdd() {
    this.$emit('submit', this.dcSelected);
  }

  closeDailog() {
    this.$emit('close');
  }

  created() {
    console.warn(this.showDCModal, this.options, this.selectedDc);
    this.dcSelected = this.selectedDc;
    this.list = this.options;
  }
}
